import React, { useState, useRef, useEffect } from "react";
import Constants from "../../constants/Constants";
const UpsellBtn = ({ dispatch, biller, nvgMember }) => {
  const [join, setJoin] = useState(false);
  const [wait, setWait] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMember, setIsMember] = useState(
    nvgMember !== "0" && nvgMember !== 0 ? true : false
  );
  const windowRef = useRef(null);
  useEffect(() => {
    if (nvgMember === "0") {
      fetch(`${Constants.API}get-status-of-unvg.php`, {
        credentials: "include",
      })
        .then((res) => res.json())
        .then((res) => {
          setIsLoading(false);
          if ("failed" in res) {
            return;
          }
          setIsMember(true);
        });
    } else {
      setIsLoading(false);
    }
  }, [nvgMember]);
  const checkEPOCHStatusPV = (event) => {
    if (
      event.origin === "https://addfriends.com" ||
      event.origin === "https://nats.netvideogirls.com" ||
      event.origin === "https://netvideogirls.com"
    ) {
      windowRef.current.close();
      if (event.data.success === "yes") {
        //the purchase if netvideogirls happened lets mark this user as success, the cron will figure out if he is actually a member.
        setIsMember(true);
        setTimeout(() => {
          dispatch({ type: "isnvgmember", payload: null });
        }, 1000);
      } else {
        //Error handle...
        setHasError(true);
        setWait(false);
        //Add Error Message here...
      }
      window.removeEventListener("message", checkEPOCHStatusPV, false);
    }
  };
  const handleEpochPurchase = () => {
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : window.screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : window.screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - 834) / 2 / systemZoom + dualScreenLeft;
    const top = (height - 834) / 2 / systemZoom + dualScreenTop;
    windowRef.current = window.open(
      "https://addfriends.com/robots-working/",
      "PurchasingVideoOnEPOCH",
      `scrollbars=yes,
      width=834, 
      height=834, 
      top=${top}, 
      left=${left}`
    );
    window.addEventListener("message", checkEPOCHStatusPV, false);
  };
  const handleJoining = () => {
    //handle
    if (wait || hasError) return;
    setWait(true);
    if (biller !== 14) {
      handleEpochPurchase();
    }
    const formData = new FormData();
    formData.append("siteid", 1);
    fetch(`${Constants.API}request-upgrade.php`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        //handle
        //array("error" => "ccbill biller, no join option.", "goout" => "https://netvideogirls.com/join");
        if ("error" in res) {
          setHasError(true);
          setWait(false);
          return;
        }

        if ("success" in res) {
          if (res.success === "yes") {
            //RG Success
            setIsMember(true);
            setTimeout(() => {
              dispatch({ type: "isnvgmember", payload: null });
              //need to dispatch the info that user is now VIP member
            }, 2000);
          } else {
            setHasError(true);
            setWait(false);
            //RG failed to load
          }
        } else {
          //Start EPOCH stuff
          if (windowRef.current) {
            windowRef.current.location.href = res.url;
          }
        }
      });
  };
  if (isLoading) {
    return null;
  }
  if (isMember) {
    return (
      <div className="tipMe mike access">
        <a href="https://vip.netvideogirls.com/" rel="noopener noreferrer">
          Login To Full Site
        </a>
        <p className="upsellInfo">
          use the same username / password as your AF account
        </p>
      </div>
    );
  }
  return (
    <div className="upContain">
      {join ? (
        <div className="tipMe mike confirm" onClick={handleJoining}>
          {wait ? <div className="nk-spinner" /> : "Confirm"}
          {hasError ? (
            <p className="upsellInfo upsellError">
              We could not processes your join, please{" "}
              <a href="https://nats.netvideogirls.com/track/MTM3MTgxLjcuMS4xLjIuMC4wLjAuMA/join">
                click here
              </a>{" "}
              and join manually sorry :(
            </p>
          ) : (
            <p className="upsellInfo">
              You will purchase netvideogirls.com for 50% off the first month
              ($15 charge). Please confirm.
            </p>
          )}
        </div>
      ) : (
        <div className="tipMe mike" onClick={() => setJoin(true)}>
          Join Now (50% Off)
          <p className="upsellInfo">
            join netvideogirls.com / castingcouch-hd.com / netgirl.com for just
            $15!
          </p>
        </div>
      )}
    </div>
  );
};

export default UpsellBtn;
